import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
news:any[]=[]; 
announcements:any[]=[];
activities:any[]=[];
// sub:Subscription[]=[];
so: any;

constructor(
  // private newsService:NewsService,
  // private announcementService:AnnouncementService,
  // private activitiesService:ActivitiesService
) {}

ngOnInit(): void {}

ngAfterContentInit(){
  // this.so = ScrollOut({
  //   onShown: function(el) {
  //     el.classList.remove('animated');
  //     void el.offsetWidth;
  //     el.classList.add('animated');
  //   }
  // });

  // ✅ We do NOT need Firebase news here anymore
  // this.newsService.getNewsList();

  // this.announcementService.getAnnouncementList();
  // this.activitiesService.getActivitiesList();

  // ✅ Stop watching Firebase updates
  // this.sub[0] = this.newsService.newsChange.subscribe(news => {
  //   this.news = news;
  // });

  // this.sub[1] = this.announcementService.announcementChange.subscribe(ann => {
  //   this.announcements = ann;
  // });

  // this.sub[2] = this.activitiesService.activitiesChange.subscribe(activities => {
  //   this.activities = activities;
  // });
}

ngOnDestroy(){
  this.so?.teardown();

  // ✅ Prevent unsubscribing non-existing Firebase subs
  // this.sub.forEach(s=>s.unsubscribe());
}
}
